import React, { Component } from 'react'
import FilterContainer from '../components/spam/FilterContainer';
import TButton from '../components/common/TButton';
import { ipMasking } from '../utils/formatter';
import {addPrefix} from "../utils/UriUtil";

class SpamFilterApp extends Component {
    constructor(props) {
        super(props);

        this.state = {
            initialFilters : props.data.spamFilter,
            filters: props.data.spamFilter,
            add : {
                ip : [],
                url : [],
                content : [],
                name : [],
            },
            remove : {
                ip : [],
                url : [],
                content : [],
                name : [],
            },

        };

        this.handleSave = this.handleSave.bind(this);
        this.appendFilter = this.appendFilter.bind(this);
        this.removeFilter = this.removeFilter.bind(this);
    }

    appendFilter(property, value){

        const { filters, add } = this.state;

        let alreadyExist = filters[property].filter((item) => (item.value === value));
        
        if(alreadyExist.length === 0){
            let append = {};
            append[property] = [{ id : null, value : value }, ...filters[property] ];

            let change = {};
            change[property] = [...add[property], { id : null, value : value } ];

            this.setState({
                filters: Object.assign({}, filters, append),
                add : Object.assign({}, add, change)
            });
        }else{
            alert('이미 등록된 내용은 추가할 수 없습니다.');
        }
    }

    removeFilter(property, value, id){

        const { filters, add, remove } = this.state;

        // 현재 화면에서 추가되었던 item을 삭제하는 거라면...
        if (id === null) {
            let removedFromAdd = add[property].filter((item, idx) => (item.value !== value));
            let removedFromFilters = filters[property].filter((item, idx) => (item.value !== value));

            let newFilters = {};
            let newAdd = {};

            newFilters[property] = removedFromFilters;
            newAdd[property] = removedFromAdd;

            this.setState({
                filters : Object.assign({}, filters, newFilters),
                add : Object.assign({}, add, newAdd),
            });

        }else{

            let removedFilters = {};
            removedFilters[property] = filters[property].filter((item) => (item.value !== value));

            let change = {};
            change[property] = [...remove[property], { id : id, value : value } ];

            this.setState({
                filters : Object.assign({}, filters, removedFilters),
                remove: Object.assign({}, remove, change)
            });
        }

    }

    handleSave(callback, failCallback){

        fetch(addPrefix("/manage/setting/comments/spam"),
            {
                method: 'put',
                credentials: 'include',
                headers: {'Content-Type':'application/json'},
                body: JSON.stringify({ add : this.state.add, remove : this.state.remove})
            })
            .then(r => r.json())
            .then(data => {
                callback();

                let filters = this.state.filters;
                Object.getOwnPropertyNames(filters).map(key => {
                    var refinedFilters = filters[key].filter((item) => (item.id && item.id != null));
                    if (data.add[key] && data.add[key].length > 0) {
                        var newFilters = data.add[key].reverse().concat(refinedFilters);
                        filters[key] = newFilters;
                    }
                });

                this.setState({
                    initialFilters: filters,
                    filters: filters,
                    add : {
                        ip : [],
                        url : [],
                        content : [],
                        name : [],
                    },
                    remove : {
                        ip : [],
                        url : [],
                        content : [],
                        name : [],
                    }
                });
            })
            .catch(e => {
                console.log(e);
                failCallback();
            });
    }

    ipInputValidator(value) {
        return /^[0-9\.]+$/.test(value);
    }

    ipValueValidator(value) {
        return /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(value);
    }

    urlInputValidator(value) {
        return /^[0-9a-zA-Z\:\/\.]+$/.test(value);
    }

    urlValueValidator(value) {
        return /^(http|https):\/\/[^ "]+$/.test(value);
    }

    render() {

        const { initialFilters, filters } = this.state;

        return (
            <form className="wrap_set type_filter">
                <p className="txt_filter">아래 필터에 포함된 내용이 댓글/방명록에 입력되면 표시를 제한하고 휴지통으로 보냅니다.</p>
                <fieldset className="fld_filter">
                    <legend className="screen_out">스팸필터 설정</legend>
                    <FilterContainer title="IP 필터링" placeholder="IP를 입력해주세요" propertyName={"ip"}
                                     emptyLabel="아직 등록된 IP가 없습니다."
                                     addFilter={this.appendFilter} removeFilter={this.removeFilter} filters={filters}
                                     inputValidator={this.ipInputValidator}
                                     actionValueValidator={this.ipValueValidator}
                                     masker={ipMasking}/>
                    <FilterContainer title="사이트 필터링" placeholder="URL을 입력해주세요" propertyName={"url"}
                                     emptyLabel="아직 등록된 사이트가 없습니다."
                                     addFilter={this.appendFilter} removeFilter={this.removeFilter} filters={filters}
                                     inputValidator={this.urlInputValidator}
                                     actionValueValidator={this.urlValueValidator}/>
                    <FilterContainer title="본문 필터링" propertyName={"content"} addFilter={this.appendFilter}
                                     emptyLabel="아직 등록된 단어가 없습니다."
                                     removeFilter={this.removeFilter} filters={filters}/>
                    <FilterContainer title="이름 필터링" propertyName={"name"} addFilter={this.appendFilter}
                                     emptyLabel="아직 등록된 단어가 없습니다."
                                     removeFilter={this.removeFilter} filters={filters}/>
                </fieldset>
                <fieldset className="fld_filter">
                    <legend className="screen_out">저장 버튼</legend>
                    <TButton onClick={this.handleSave} initialValues={initialFilters} currentValues={filters}/>
                </fieldset>
            </form>
        );
    }
}

export default SpamFilterApp;
